import { render, staticRenderFns } from "./button-restore-password.vue?vue&type=template&id=748e56ed&"
import script from "./button-restore-password.vue?vue&type=script&lang=js&"
export * from "./button-restore-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports